import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

declare var ENVIRONMENT_CONFIG: any;

@Injectable()
export class LLSHttpInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = req.clone({url: this.prepareUrl(req.url)});
        return next.handle(req);
    }

    private isAbsoluteUrl(url: string): boolean {
        const absolutePattern = /^https?:\/\//i;
        return absolutePattern.test(url);
    }

    private prepareUrl(url: string): string {
        if (!this.isAbsoluteUrl(url)) {
            url = ENVIRONMENT_CONFIG.apiUrl + '/' + url;
        }
        return url.replace(/([^:]\/)\/+/g, '$1');
    }
}
